module.exports = __webpack_public_path__ + "static/home_wideodermatoskopia-9de197d247bd0853b9b71b82865dd87d.png";